import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfileService } from '../../modules/usermanagement/services/user-profile.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css']
})
export class AccessDeniedComponent implements OnInit {
  userRole: string = '';
  redirectRoute: string = '/';

  constructor(
    private router: Router,
    private userProfileService: UserProfileService
  ) { }

  ngOnInit(): void {
    const userProfile = this.userProfileService.getCurrentUserProfile();
    this.userRole = userProfile?.roleName || 'User';

    // Determine the correct home route based on user's role
    const visibleMenuItems = this.userProfileService.getVisibleMenuItems();
    if (visibleMenuItems.length > 0) {
      this.redirectRoute = visibleMenuItems[0].route;
    }
  }

  goToHome(): void {
    this.router.navigate([this.redirectRoute]);
  }
}
